import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomValidators } from 'src/app/core/constants/validators';
import { Product } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductAttributeSelectionsService {
  private formBuilder = inject(FormBuilder);

  attributeSelections: FormGroup = this.formBuilder.group({});
  attributeSelections$: Observable<Record<string, string | null>> = this.attributeSelections.valueChanges;

  prepareAttributeForm(product: Product) {

    const {
      variant_values = [],
    } = product || {};

    let primary_attribute = product?.variant_group?.primary_attribute ?? '';

    // set the first property as primary if none set from admin
    if (!primary_attribute) {
      primary_attribute = variant_values?.[0]?.key ?? '';
    }

    // prepare form
    if (Array.isArray(variant_values)) {
      this.attributeSelections = this.formBuilder.group({});
      this.attributeSelections$ = this.attributeSelections.valueChanges;

      variant_values.sort((v1, v2) => v1.key === primary_attribute ? -1 : 0);

      // only set value if primary attribute, others will be selected by user
      variant_values.forEach((variant_value) => {
        const { key = '', value = '' } = variant_value || {};
        // only select the primary variant
        const requiredValidator: ValidatorFn = CustomValidators.required || (() => null);
        this.attributeSelections.addControl(key,
          this.formBuilder.control(value, [requiredValidator]));


      });
    }
  }
}
